<template>
  <div class="edit-okr">
    <div class="breadcrumb">
      <a-breadcrumb
        v-show="breadSubTitle"
        separator=">"
      >
        <a-breadcrumb-item>
          <router-link :to="breadTitleLink">
            部门考评
          </router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>{{ breadSubTitle }}</a-breadcrumb-item>
      </a-breadcrumb>
      <div class="okr-time">
        {{ timeTips }}
      </div>
    </div>

    <div
      v-for="(item, index) in okrList"
      :key="index"
      class="edit-okr__item"
    >
      <div
        v-for="(oItem, oIndex) in item.objectList"
        :key="oIndex"
        class="edit-okr__itemObject"
      >
        <div class="edit-okr__header">
          <div class="boxL">
            <span class="m-o-weight">
              目标权重={{ oItem.weight }}%
            </span>
            <div class="m-o-content">
              {{ oItem.objectDetail }}
            </div>
          </div>
          <div>
            <div
              v-if="!oItem.haveWeight"
              class="objectScore"
            >
              无效的目标，无法计算目标得分
            </div>
            <div
              v-else-if="!oItem.objectScore"
              :class="oItem.noScore?'objectScore wrongTxt':'objectScore'"
            >
              未完成填写，无法计算目标得分
            </div>
            <div
              v-else
              class="objectScore"
            >
              目标得分<strong>{{ oItem.objectScore }}</strong>分
            </div>
            <a
              v-show="oItem.haveWeight"
              class="boxControl"
              @click="handleControl(oItem)"
            >
              {{ oItem.isShow ? '收起' : '展开' }} <a-icon :type="oItem.isShow ? 'up' : 'down'" />
            </a>
          </div>
        </div>
        <div
          v-if="oItem.isShow"
          class="edit-okr__object"
        >
          <div
            v-for="(krItem, krIndex) in oItem.keyResultList"
            :key="krIndex"
          >
            <div
              v-if="krItem.haveWeight"
              class="edit-okr__content"
            >
              <div class="edit-okr__krBox boxAuto boxFlex">
                <div class="krLBox">
                  <span class="m-kr-weight">权重 = {{ krItem.weight }}%</span>
                  <div class="m-kr-content">
                    {{ krItem.keyResultDetail }}
                  </div>
                </div>
                <div class="krLBox">
                  <span class="m-kr-tag">7分</span>
                  <div class="m-kr-content">
                    {{ krItem.sevenTarget }}
                  </div>
                  <span class="m-kr-tag">10分</span>
                  <div class="m-kr-content">
                    {{ krItem.tenTarget }}
                  </div>
                </div>
                <div class="boxAuto">
                  <span class="m-kr-weight">自评得分</span>
                  <span class="m-kr-score"><span>{{ krItem.selfEvaluateWithScore }}</span> 分</span>
                  <div class="m-kr-content">
                    {{ krItem.selfEvaluateWithWords }}
                  </div>
                </div>
              </div>
              <div class="edit-okr__krBox">
                <div class="krSEinner">
                  <strong>考评</strong>
                  <div>
                    <span
                      v-show="krItem.noScore"
                      class="wrongTxt"
                    >请选择</span>
                    <a-radio-group
                      button-style="solid"
                      size="small"
                      :default-value="krItem.direEvaluateWithScore | formatToString"
                      @change="(e) => handleKrDEScoreChange(index, oIndex, krIndex,'direEvaluateWithScore', e.target.value)"
                    >
                      <a-radio-button value="4">
                        4分
                      </a-radio-button>
                      <a-radio-button value="7">
                        7分
                      </a-radio-button>
                      <a-radio-button value="10">
                        10分
                      </a-radio-button>
                    </a-radio-group>
                  </div>
                </div>
                <!-- textarea 组件的样式是动态计算的，需要强制覆盖; 用max-length控制最多可输入1000字（不区分中英文） -->
                <a-textarea
                  style="min-height: 80px; line-height: 30px;"
                  :class="krItem.noWords? 'wrongBox': ''"
                  :placeholder="krItem.placeholder"
                  :disabled="krItem.disEdit"
                  maxlength="1000"
                  :autosize="{ minRows: 2 }"
                  :value="krItem.direEvaluateWithWords"
                  @blur="(e) => formateKrDEWords(index, oIndex, krIndex, 'direEvaluateWithWords', e.target.value)"
                  @change="(e) => handleKrDEWordsChange(index, oIndex, krIndex, 'direEvaluateWithWords', e.target.value)"
                  @focus="(e) => handleKrDEWordsClear(index, oIndex, krIndex, 'direEvaluateWithWords')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="edit-okr__totalBox">
        <div class="okrSELine">
          <div class="okrDEScore">
            自评
            <span>{{ item.selfEvaluateOn271 }}</span>
            业绩自评
            <span>{{ item.selfEvaluateWithScore }}</span>
          </div>
          <span class="m-kr-weight towrap">自评 · 亮点或不足</span>
          <div>{{ item.highlightAndWeakness ? item.highlightAndWeakness : '-' }}</div>
        </div>
        <div
          v-show="quarter==='2'|| quarter==='4'"
          class="totalTips"
        >
          <a-icon
            type="info-circle"
            style="color: #0064fa;"
            theme="filled"
          /> 半年度考评请注意：以下内容需参考半年的绩效表现进行半年度上级评哦
        </div>
        <div class="krSEinner">
          <div>
            <strong style="margin-right:8px;">考评</strong>
            <a-radio-group
              button-style="solid"
              size="large"
              :default-value="item.direEvaluateOn271"
              @change="(e) => handleOkrDEScoreChange(index,'direEvaluateOn271',e.target.value)"
            >
              <a-radio-button value="1">
                1
              </a-radio-button>
              <a-radio-button value="6">
                6
              </a-radio-button>
              <a-radio-button value="3">
                3
              </a-radio-button>
            </a-radio-group>
            <span
              v-show="item.noScore"
              class="wrongTxt"
            >请选择</span>
          </div>
          <div class="okrScoreBox">
            <strong>业绩考评</strong><strong class="scoreTxt"><span v-show="item.okrDETotalScore !== 0">{{ item.okrDETotalScore }}</span></strong><span class="tipsTxt">分</span>
          </div>
        </div>
        <div v-show="item.direEvaluateOn271">
          <div>
            <strong>亮点或不足</strong>
            <span
              :class="item.isMust?'tipsTxt2':'tipsTxt1'"
            >{{ item.isMust ? '（必填）':'（选填）' }}</span>
          </div>
          <a-textarea
            style="min-height: 80px; line-height: 30px; margin-top:8px;"
            :class="item.noWords? 'wrongBox': ''"
            placeholder="361考评为3或1时，考评人需要根据被考评人的实际情况进行点评；请参照“STAR原则”填写具体数据或具体案例支撑，此部分内容结合业绩自评完成情况将运用于合议会，作为季度或半年度绩效结果361的参考"
            maxlength="1000"
            :autosize="{ minRows: 2 }"
            :value="item.highlightAndWeakness2"
            @blur="(e) => formateOkrDEWords(index, 'highlightAndWeakness2',e.target.value)"
            @change="(e) => handleOkrDEWordsChange(index, 'highlightAndWeakness2',e.target.value)"
            @focus="(e) => handleOkrDEWordsClear(index, 'highlightAndWeakness2')"
          />
        </div>
      </div>
    </div>
    <div class="edit-okr__footer">
      <a-button
        type="primary"
        ghost
        @click="handleClickSave"
      >
        存草稿
      </a-button>
      <a-button
        class="edit-okr__submit"
        type="primary"
        ghost
        @click="handleClickSubmit"
      >
        提交
      </a-button>
    </div>
    <a-modal
      v-model="isSucess"
      centered
      :mask-closable="false"
      :width="430"
      :footer="null"
      :closable="false"
    >
      <div class="sucessOuter">
        <img
          class="sucessIco"
          src="@assets/images/up-success.png"
        >
        <div class="sucessTxt">
          提交成功！
        </div>
        <div class="sucessTips">
          {{ CountDown }}秒
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { Input, Button, Icon, Radio, Modal, message, Breadcrumb, Notification } from 'ant-design-vue'

import { mapState } from 'vuex'

Vue.use(Input)
Vue.use(Button)
Vue.use(Icon)
Vue.use(Radio)
Vue.use(Modal)
Vue.use(Breadcrumb)
Vue.use(Notification)

export default {
  name: 'EditDireEvaluation',
  filters: {
    formatToString(value) {
      const v = value.toString()
      return v
    },
  },
  data() {
    return {
      okrList: [],
      okrDEList: [],
      originalDEList: [],
      okrId: null,
      year: '',
      quarter: '',
      isSucess: false,
      CountDown: '',
      breadTitleLink: '',
      breadSubTitle: '',
      timeTips: '',
      haveChange: false,
    }
  },
  computed: {
    ...mapState({
      currentTime: state => state.serverTime,
    //   userId: state => state.userId,
    }),
    userId: {
      get () {
        return this.$store.state.userId
      },
      set () {},
    },
  },
  watch: {
    userId() {
      this.fetchEditDATa()
    },
    haveChange(r) {
      // 默认将离开页面的浏览器事件置空
      window.onbeforeunload = null
      if (r) {
        window.onbeforeunload = function(e) {
          e = window.event || e
          e.returnValue = ('您的数据尚未保存，确定离开当前页面吗？')
        }
      }
    },
  },
  async created() {
    this.$store.dispatch('getServerTime')
    const okrId = this.$route.params.okrId
    if (okrId) {
      this.okrId = okrId
    }
    // 若userId不为空，则不用等监听，直接执行函数 （从详情点编辑当前页面跳转时会停留在空白页面的bug）
    if (this.userId) {
      this.fetchEditDATa()
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.haveChange) {
      Modal.confirm({
        title: '是否保存此次编辑内容？',
        content: '保存后下次可继续编辑。',
        icon: 'exclamation-circle',
        okText: '保存',
        cancelText: '不保存',
        onOk: () => {
          this.handleClickSave()
          next()
        },
        onCancel: () => {
          next()
          // 若不保存，将离开页面的浏览器事件置空，以免影响列表页操作
          window.onbeforeunload = null
        },
      })
    } else {
      next()
    }
  },
  beforeDestory () {
    // 页面销毁前，将事件置空
    window.onbeforeunload = null
  },
  methods: {
    // 获取自评保存数据
    async fetchEditDATa() {
      const hide = message.loading('正在加载...')
      try {
      // 进入编辑，从接口拿自评数据
        const result = await this.$api.okr.getTempDE({ id: this.okrId })
        // eslint-disable-next-line
        console.log('getTempDE result', result)

        // 判断该okr对应用户是否是登录用户，如果不匹配，报错
        // if (result.userId !== this.userId) {
        //   message.error('您无权编辑该条OKR自评记录')
        // } else {

        this.breadSubTitle = `${result.year}年Q${result.quarter}季度考评 - ${result.searchStaffInfo.userName}`
        this.breadTitleLink = `/direEvaluationList?year=${result.year}&quarter=${result.quarter}`
        document.title = `${result.searchStaffInfo.userName}的${result.year}年Q${result.quarter}季度考评`
        this.quarter = `${result.quarter}`
        if (result.selfEvaluationState === 1) {
          this.timeTips = `${result.searchStaffInfo.userName} ${result.selfEvaluateTime} 提交自评表`
        } else {
          this.timeTips = `${result.searchStaffInfo.userName} 待自评`
        }

        // 判断selfEvaluationState  未提交：-1 待提交：0 已提交：1
        switch (result.selfEvaluationState) {
          case -1:
            result.objectList.forEach(objItem => {
              objItem.keyResultList.forEach(krItem => {
                this.$set(krItem, 'selfEvaluateWithWords', '超时未自评')
              })
            })
            break
          case 0:
            result.objectList.forEach(objItem => {
              objItem.keyResultList.forEach(krItem => {
                this.$set(krItem, 'selfEvaluateWithWords', '待自评')
              })
            })
            break
        }

        // 初始化数据：插入展开收起属性、插入校验属性、删除权重为0的kr以及O权重为0时所有kr
        result.objectList.forEach(objItem => {
          let allKrNoWeight = true
          if (objItem.weight !== 0) {
            objItem.keyResultList.forEach(krItem => {
              if (krItem.weight !== 0) {
                this.$set(krItem, 'noScore', false)
                this.$set(krItem, 'noWords', false)
                this.$set(krItem, 'haveWeight', true)
                allKrNoWeight = false
              } else {
                this.$set(krItem, 'haveWeight', false)
                if (allKrNoWeight) {
                  allKrNoWeight = true
                } else {
                  allKrNoWeight = false
                }
              }
              if (krItem.direEvaluateWithScore > 0) {
                this.$set(krItem, 'disEdit', false)
                if (krItem.direEvaluateWithScore === krItem.selfEvaluateWithScore) {
                  this.$set(krItem, 'placeholder', '如有需要可填写')
                } else {
                  this.$set(krItem, 'placeholder', '考评与自评不一致，请填写得分评语')
                }
              } else {
                this.$set(krItem, 'direEvaluateWithScore', -1)
                this.$set(krItem, 'disEdit', true)
                this.$set(krItem, 'placeholder', '请先选择考评得分')
              }
            })
            if (allKrNoWeight) {
              this.$set(objItem, 'haveWeight', false)
            } else {
              this.$set(objItem, 'haveWeight', true)
            }
            this.$set(objItem, 'isShow', true)
            this.$set(objItem, 'noScore', false)
          } else {
            this.$set(objItem, 'haveWeight', false)
          }
        })
        this.$set(result, 'noScore', false)
        this.$set(result, 'noWords', false)
        if (result.direEvaluateOn271 === '3' || result.direEvaluateOn271 === '1') {
          this.$set(result, 'isMust', true)
        } else {
          this.$set(result, 'isMust', false)
        }

        this.okrList.push(result)
        // 计算分数
        this.calculateScore()
        // eslint-disable-next-line
          console.log('okrList',this.okrList)
        // 收集提交的数据并赋值给原始数组，用于跟离开页面时的数组进行对比，如果不同，则提示保存
        this.spliArray()
        this.originalDEList = this.okrDEList
      // }
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      } finally {
        hide()
      }
    },
    // 展开收起
    handleControl(r) {
      r.isShow = !r.isShow
    },
    /**
     * 计算o的分数以及总分
     */
    calculateScore() {
      this.okrList.forEach(item => {
        let krTotal = 0
        let objTotal = 0
        let objTotalCopy = 0
        let okrTotal = 0
        item.objectList.forEach(objItem => {
          let allKrhaveScore = true
          objItem.keyResultList.forEach(krItem => {
            if (krItem.direEvaluateWithScore > 0) {
              krTotal += krItem.weight * krItem.direEvaluateWithScore / 100
            } else {
              // 有权重且没有打分，则不能进入计算
              if (krItem.haveWeight) {
                allKrhaveScore = false
              }
            }
          })
          // eslint-disable-next-line
          console.log('allKrhaveScore', allKrhaveScore)
          if (allKrhaveScore) {
            objTotal = Math.round(krTotal * objItem.weight / 10) / 10
            objTotalCopy = (krTotal * objItem.weight / 10) / 10
            krTotal = 0
            this.$set(objItem, 'objectScore', objTotal)
            okrTotal += objTotalCopy
          }
        })
        okrTotal = Math.round(okrTotal * 10) / 10
        this.$set(item, 'okrDETotalScore', okrTotal)
      })
    },
    /**
     * kr direEvaluateWithScore 字段改变，加入数组
     * @param {Number} index 外层索引
     * @param {Number} oIndex O 的索引
     * @param {Number} krIndex KR 的索引
     * @param {String} k 字段名
     * @param {any} v 值
     */
    handleKrDEScoreChange(index, oIndex, krIndex, k, v) {
      v = Number(v)
      const krItem = this.okrList[index].objectList[oIndex].keyResultList[krIndex]
      if (krItem.direEvaluateWithWords === '考评与自评不一致，请填写得分评语') {
        krItem.direEvaluateWithWords = ''
        krItem.noWords = false
      }

      this.$set(krItem, k, v)
      this.$set(krItem, 'noScore', false)
      this.$set(krItem, 'disEdit', false)

      if (v === krItem.selfEvaluateWithScore) {
        this.$set(krItem, 'placeholder', '如有需要可填写')
      } else {
        this.$set(krItem, 'placeholder', '考评与自评不一致，请填写得分评语')
      }
      // eslint-disable-next-line
      console.log('点击分数改变okrList', this.okrList)
      this.calculateScore()
    },
    /**
     * direEvaluateWithWords 格式化文本，多个空格合并成一个，并加入数组
     * @param {Number} index 外层索引
     * @param {Number} oIndex O 的索引
     * @param {Number} krIndex KR 的索引
     * @param {String} k 字段名
     * @param {any} v 值
     */
    formateKrDEWords(index, oIndex, krIndex, k, v) {
      v = v.replace(/[ ]+/g, ' ')
      const krItem = this.okrList[index].objectList[oIndex].keyResultList[krIndex]
      this.$set(krItem, k, v)
      this.compareData()
    },
    /**
     * direEvaluateWithWords 字段改变，加入数组
     * @param {Number} index 外层索引
     * @param {Number} oIndex O 的索引
     * @param {Number} krIndex KR 的索引
     * @param {String} k 字段名
     * @param {any} v 值
     */
    handleKrDEWordsChange(index, oIndex, krIndex, k, v) {
      const krItem = this.okrList[index].objectList[oIndex].keyResultList[krIndex]
      this.$set(krItem, k, v)
      this.$set(krItem, 'noWords', false)
      this.compareData()
    },
    /**
     * direEvaluateWithWords 字段清空（校验报错时，增加报错文本，获取焦点清空该文本），加入数组
     * @param {Number} index 外层索引
     * @param {Number} oIndex O 的索引
     * @param {Number} krIndex KR 的索引
     * @param {String} k 字段名
     */
    handleKrDEWordsClear(index, oIndex, krIndex, k) {
      const krItem = this.okrList[index].objectList[oIndex].keyResultList[krIndex]
      if (krItem.noWords) {
        this.$set(krItem, k, '')
        this.$set(krItem, 'noWords', false)
        this.compareData()
      }
    },
    /**
     * direEvaluateOn271 字段改变，加入数组，展开收起亮点不足
     * @param {Number} index 外层索引
     * @param {String} k 字段名
     * @param {any} v 值
     */
    handleOkrDEScoreChange(index, k, v) {
      if (v === '3' || v === '1') {
        this.okrList[index].isMust = true
      } else {
        this.okrList[index].isMust = false
        this.$set(this.okrList[index], 'noWords', false)
      }
      this.$set(this.okrList[index], k, v)
      this.$set(this.okrList[index], 'noScore', false)
      this.compareData()
    },
    /**
     * highlightAndWeakness2 格式化文本，多个空格合并成一个，并加入数组
     * @param {Number} index 索引
     * @param {String} k 字段名
     * @param {any} v 值
     */
    formateOkrDEWords(index, k, v) {
      v = v.replace(/[ ]+/g, ' ')
      this.$set(this.okrList[index], k, v)
      this.compareData()
    },
    /**
     * highlightAndWeakness2 字段改变，加入数组
     * @param {Number} index 索引
     * @param {String} k 字段名
     * @param {any} v 值
     */
    handleOkrDEWordsChange(index, k, v) {
      this.$set(this.okrList[index], k, v)
      this.$set(this.okrList[index], 'noWords', false)
      this.compareData()
    },
    /**
     * highlightAndWeakness2 字段清空（校验报错时，增加报错文本，获取焦点清空该文本），加入数组
     * @param {Number} index 索引
     * @param {String} k 字段名
     */
    handleOkrDEWordsClear(index, k) {
      if (this.okrList[index].noWords) {
        this.$set(this.okrList[index], k, '')
        this.$set(this.okrList[index], 'noWords', false)
        this.compareData()
      }
    },
    /**
     * 将保存/提交数据从页面数据中抽取出来
     */
    spliArray() {
      this.okrList.forEach(item => {
        const tmpKrs = []
        item.objectList.forEach(objItem => {
          objItem.keyResultList.forEach(krItem => {
            if (krItem.direEvaluateWithWords === '考评与自评不一致，请填写得分评语') {
              krItem.direEvaluateWithWords = ''
            }
            tmpKrs.push({
              id: krItem.id,
              evaluateWithScore: krItem.direEvaluateWithScore || -1,
              evaluateWithWords: krItem.direEvaluateWithWords || '',
            })
          })
        })
        if (item.highlightAndWeakness2 === '361考评为3或1时，必须填写亮点或不足') {
          item.highlightAndWeakness2 = ''
        }
        this.okrDEList = {
          direEvaluateOn271: item.direEvaluateOn271 || '',
          highlightAndWeakness2: item.highlightAndWeakness2 || '',
          krEvaluationList: tmpKrs,
          id: this.okrId,
        }
      })
    },

    /**
     * 点击保存按钮
     */
    async handleClickSave() {
      this.spliArray()
      try {
        await this.$api.okr.preserveDE(this.okrDEList)
        Notification.open({
          type: 'success',
          message: '已保存',
          description:
            '已为您保存成功啦~',
          style: 'background-color:#E4FDDA',
        })
        this.originalDEList = this.okrDEList
        this.haveChange = false
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      }
    },
    /**
     * 点击提交按钮
     */
    handleClickSubmit() {
      // 判断是否有为空的情况，报错提醒
      let haveBlank = false
      this.okrList.forEach(item => {
        if (!item.direEvaluateOn271) {
          item.noScore = true
          haveBlank = true
        }
        item.objectList.forEach(objItem => {
          if (objItem.weight !== 0) {
            let allKrisOk = true
            objItem.keyResultList.forEach(krItem => {
              if (krItem.weight !== 0) {
                if (krItem.direEvaluateWithScore === -1) {
                  krItem.noScore = true
                  haveBlank = true
                  allKrisOk = false
                }
                if (
                  krItem.placeholder === '考评与自评不一致，请填写得分评语' && (!krItem.direEvaluateWithWords || krItem.noWords)
                ) {
                  krItem.noWords = true
                  krItem.direEvaluateWithWords = '考评与自评不一致，请填写得分评语'
                  haveBlank = true
                  allKrisOk = false
                }
              }
            })
            if (objItem.objectScore < 0 || !allKrisOk) {
              objItem.noScore = true
              haveBlank = true
              objItem.isShow = true
            }
          }
        })

        if (!item.direEvaluateOn271) {
          item.noScore = true
          haveBlank = true
        }
        if (item.noWords) {
          haveBlank = true
        }
        if (item.isMust && (!item.highlightAndWeakness2 || item.highlightAndWeakness2 === '361考评为3或1时，必须填写亮点或不足')) {
          item.noWords = true
          item.highlightAndWeakness2 = '361考评为3或1时，必须填写亮点或不足'
          haveBlank = true
        }
      })
      // eslint-disable-next-line
      console.log('haveBlank', haveBlank)
      if (haveBlank) {
        // eslint-disable-next-line
        // console.log('okrList',this.okrList)
        Notification.open({
          type: 'error',
          message: '未完成表单填写',
          description:
            '未完成表单填写，请注意红色提示文字。',
          style: 'background-color:#FFECE4',
        })
      } else {
        this.spliArray()
        // 上传数据
        this.submitData()
      }
    },
    /**
     * 提交考评表单数据
     */
    async submitData() {
      // eslint-disable-next-line
      console.log('okrDEList',this.okrDEList)
      try {
        await this.$api.okr.submitDE(this.okrDEList)
        this.haveChange = false

        // 提交成功 3秒倒计时
        this.isSucess = true
        const TIME_COUNT = 3
        this.CountDown = TIME_COUNT
        this.timer = setInterval(() => {
          if (this.CountDown > 1 && this.CountDown <= TIME_COUNT) {
            this.CountDown--
          } else {
            clearInterval(this.timer)
            this.timer = null
            // 跳转的页面写在此处
            this.$router.replace({
              name: 'DireEvaluationDetail',
              params: {
                okrId: this.okrId,
              },
            })
          }
        }, 1000)
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      }
    },
    /**
     * 收集表单数组，跟进入页面加载时数据进行对比，若不同，返回true
     */
    compareData() {
      this.spliArray()
      this.haveChange = false
      if ((this.originalDEList.direEvaluateOn271 !== this.okrDEList.direEvaluateOn271) || (this.originalDEList.highlightAndWeakness2 !== this.okrDEList.highlightAndWeakness2)) {
        this.haveChange = true
      } else {
        this.originalDEList.krEvaluationList.forEach(oik => {
          this.okrDEList.krEvaluationList.forEach(ik => {
            if ((oik.evaluateWithScore !== ik.evaluateWithScore) || (oik.evaluateWithWords !== ik.evaluateWithWords)) {
              this.haveChange = true
            }
          })
        })
      }
      // eslint-disable-next-line
      console.log('this.haveChange', this.haveChange)
    },
  },
}
</script>

<style lang="less">
@import '~@assets/style/variables.less';

.edit-okr {position: relative; padding-bottom: 66px;
  &__item {
    padding: 16px 16px 56px 16px;
    background: #E8EAED;
  }
  &__itemObject{
      margin-bottom: 16px;
  }
  &__header,
  &__krBox,
  &__totalBox {
    background: @white;
    border-radius: 4px;
    padding: 16px;
  }
  &__krBox{
    &:last-child{
        width:25%;
        margin-left: 4px;
        min-width: 300px;
    }
  }
  .boxAuto{
    flex:1;
    font-size:0;
    position: relative;
  }
  .boxFlex{
    display: flex;
  }
  .krLBox{
      width:34%;
      padding-right: 16px;
      border-right:#EFF0F2 1px solid;
      margin-right: 16px;
  }
  &__header {
    position: relative;
    min-height: 80px;
    font-size:13px;
    padding-right: 160px;
  }
  &__content {
    display: flex;
    margin-top: 4px;
  }
  &__footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 64px;
    padding: 0 170px;
    background: @white;
    z-index: 2;
    > button {
      padding: 0 30px;
      margin-left: 12px;
    }
  }
  &__submit {
    background: #005EFE;

    &:hover,
    &:active,
    &:focus {
      background: @blue;
    }
  }
}
.breadcrumb{
margin-bottom: 40px;
padding-bottom:16px;
border-bottom: 1px solid #DDD;
}
.okr-time{
position:absolute;
right: 0;
top:38px;
height: 40px;
line-height: 40px;
font-size:13px;
color:#ccc;
}
.objectScore{position: absolute; top:8px; right:16px; color:#bbb;
strong{color:@blue; padding: 0 4px;}
}
.boxControl{position: absolute; bottom:18px; right:20px;}
.m-o-weight{display:inline-block; background:#EAF4FF url('~@images/mIco-target.png') no-repeat left center; background-size: 16px 16px; padding:0 4px 0 16px; color:@blue;  font-weight: 500;}
.m-kr-weight,.m-kr-tag{display:inline-block; background-color: #F0F2F5; padding: 0 4px; height: 20px; line-height: 20px; font-size: 13px; font-weight: 500; color:#999;}
.m-kr-weight{margin-bottom: 10px;}
.m-o-content,.m-kr-content{ margin-top: 8px; font-size:14px; color:#444; line-height: 1.6;}
.m-kr-content{font-size: 13px; color:#666;}
.m-kr-tag{width:40px; text-align: center;}
.m-kr-content + .m-kr-tag{margin-top: 16px;}
.m-kr-score{position:absolute; top:0; right:0; font-size: 13px; color:#bbb;
span{color:@blue; font-weight: 500; font-size: 14px;}}
.totalTips{font-size: 14px; color:#999; padding-bottom: 16px;}
.krSEinner{padding-bottom: 16px;display: flex; justify-content: space-between;}
.towrap + div{white-space: pre-line;}
.tipsTxt,.tipsTxt2{font-size: 14px;color:#bbb;}
.tipsTxt2{color:#FF3000;}
.wrongTxt{font-size:13px; color:#FF3000; padding: 0 4px;}
.edit-okr__totalBox{
.krSEinner{font-size:16px;}
.wrongTxt{font-size:14px;}
}
.scoreTxt{font-size:24px;color:@blue; display: inline-block; width:48px; text-align: center;
 span{position: relative; top:-2px;}}
.wrongBox{border-color:#FF3000; color:#FF3000;}
.okrScoreBox{display: flex; align-items: center;}
.sucessOuter{text-align: center;}
.sucessIco{width:66px; margin-top: 16px; margin-bottom: 18px;}
.sucessTxt{font-size:14px; margin-bottom: 30px;}
.sucessTips{font-size: 12px; color:#9B9B9B;padding-bottom: 16px;}
.ant-radio-group-large .ant-radio-button-wrapper{width:64px; text-align: center;}
.okrSELine{margin-bottom: 15px; border-bottom: #EFF0F2 1px solid; padding-bottom: 15px;}
.okrDEScore{font-size: 16px; font-weight: bold; padding-bottom: 12px;
span{font-size: 24px;color: @blue; padding: 0 32px 0 8px;}}
.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {background: @blue; border-color:@blue;}
</style>
